import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class Globals {
  static tenantId: string;
  static tenantName: string;
}
